module.exports = __webpack_public_path__ + "img/contacto_16-9_2880.fc9f3cbf.webp";